// 125000 -> "125,000". Returns '' for null/undefined so empty cells stay blank,
// and passes anything unparseable through unchanged rather than printing NaN.
export const formatMoney = (value) => {
    if (value === null || value === undefined || value === '') return '';
    const number = Number(value);
    if (!isFinite(number)) return String(value);
    return number.toLocaleString('en-US');
};
